import { BaseResponse } from './base.response';
import{ User } from '../models';

export class UsersResponse extends BaseResponse {

  public users: User[];

}
